<template>
  <div class="assetsStatistics">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="$t.enterpriseLogistics.searchText1"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-tabs
      v-model="menuState"
      @change="stateChanged"
      title-active-color="#009ed4"
      color="#009ed4"
      swipeable
    >
      <van-tab
        v-for="(menu, index) in menuList"
        :key="index"
        :title="menu.title + (menu.count > 0 ? ' ' + menu.count : '')"
        :name="menu.name"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="firstLoad(page + 1)"
        >
          <div class="list-container" v-for="(item, index) in tableData" :key="index">
            <template v-if="menuState == 2">
              <div class="list-item">
                {{ $t.enterpriseLogistics.assetClassName }}：{{ item.AssetName }}
              </div>
              <div class="list-item">
                {{ $t.enterpriseLogistics.accountName }}：{{ item.AccountName }}
              </div>
              <div class="list-item">
                {{ $t.enterpriseLogistics.accountNumber }}：{{ item.AccountNumber }}
              </div>
              <div class="list-item">
                {{ $t.enterpriseLogistics.setMealConfig }}：{{ item.SetMealConfig }}
              </div>
              <div class="list-item">
                {{ $t.enterpriseLogistics.openingDate }}：{{ item.AccountOpeningDate }}
              </div>
              <div class="list-item">
                {{ $t.enterpriseLogistics.purchaseAmount }}：{{ item.PurchaseAmount }}
              </div>
              <div class="list-item">
                {{ $t.enterpriseLogistics.assetState }}：
                <span v-if="item.AssetState == 0">{{
                  $t.enterpriseLogistics.aState1
                }}</span>
                <span v-if="item.AssetState == 1">{{
                  $t.enterpriseLogistics.aState2
                }}</span>
              </div>
            </template>
            <template v-else>
              <div class="list-item">
                {{ $t.enterpriseLogistics.assetClassName }}：{{ item.AssetName }}
              </div>
              <div class="list-item">
                {{ $t.enterpriseLogistics.goodsName }}：{{ item.ProductName }}
              </div>
              <div class="list-item">
                {{ $t.enterpriseLogistics.goodsModel }}：{{ item.ProductModel }}
              </div>
              <div class="list-item">
                {{ $t.enterpriseLogistics.goodsBrand }}：{{ item.ProductBrand }}
              </div>
              <div class="list-item">
                {{ $t.enterpriseLogistics.goodsConfig }}：{{ item.ProductConfig }}
              </div>
              <div class="list-item">
                {{ $t.enterpriseLogistics.purchaseDate }}：{{ item.PurchaseDate }}
              </div>
              <div class="list-item">
                {{ $t.enterpriseLogistics.purchaseAmount }}：{{ item.PurchaseAmount }}
              </div>
              <div class="list-item">
                {{ $t.enterpriseLogistics.assetState }}：
                <span v-if="item.AssetState == 0">{{
                  $t.enterpriseLogistics.aState1
                }}</span>
                <span v-if="item.AssetState == 1">{{
                  $t.enterpriseLogistics.aState2
                }}</span>
              </div>
            </template>

            <div class="buttons">
              <van-button
                class="default-btn"
                size="small"
                type="primary"
                @click="gotoRecord(item.AssetId)"
                >{{ $t.enterpriseLogistics.handoverRecord }}</van-button
              >

              <van-button
                class="primary-btn"
                size="small"
                type="primary"
                @click="gotoDetail(item.AssetId)"
                >{{ $t.meta.editButton }}</van-button
              >

              <van-button
                class="danger-btn"
                size="small"
                type="primary"
                @click="deleteAssetInfo(item.AssetId)"
              >
                {{ $t.meta.delete }}
              </van-button>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <span v-if="categoryList.length > 0">
          <div class="radio-label">{{ $t.enterpriseLogistics.assetType }}</div>
          <van-radio-group v-model="acid" direction="horizontal">
            <van-radio
              :name="item.ACId"
              v-for="(item, index) in categoryList"
              :key="index"
              >{{ item.AssetName }}</van-radio
            >
          </van-radio-group>
        </span>

        <div class="radio-label">{{ $t.enterpriseLogistics.assetState }}</div>
        <van-radio-group v-model="state" direction="horizontal">
          <van-radio :name="1">{{ $t.enterpriseLogistics.aState1 }}</van-radio>
          <van-radio :name="2">{{ $t.enterpriseLogistics.aState2 }}</van-radio>
        </van-radio-group>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <van-dialog
      :title="$t.enterpriseLogistics.addClass"
      width="90%"
      v-model="dialogAssetVisible"
      @confirm="dialogConfirm"
      @cancel="dialogCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="assetsStatistics-alert">
          <van-form label-width="120px">
            <van-field
              v-model="dialogAssetForm.AssetTypeName"
              :label="$t.enterpriseLogistics.assetType"
              @click="pickerShow"
              :placeholder="$t.meta.select"
              clickable
              readonly
            />

            <van-field
              v-model="dialogAssetForm.AssetName"
              :label="$t.enterpriseLogistics.className"
              :placeholder="$t.meta.input"
              required
            />
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <van-popup v-model="showAssetPicker" round position="bottom">
      <van-picker
        :title="$t.enterpriseLogistics.assetType"
        show-toolbar
        :columns="assetTypeOptions"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="assetConfirm($event)"
        @cancel="showAssetPicker = false"
      />
    </van-popup>

    <van-action-sheet v-model="sheetShow" :actions="sheetActions" @select="sheetSelect" />

    <div class="tool-bar">
      <van-button type="info" block @click="handleSheetShow">{{
        $t.meta.menu
      }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  Picker,
  DatetimePicker,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(Picker)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup)
  .use(Tab)
  .use(Tabs);

export default {
  name: "assetsStatistics",
  data() {
    return {
      menuState: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      menuList: [
        {
          title: this.$t.enterpriseLogistics.fixedAssets,
          name: 1,
          count: 0,
        },
        {
          title: this.$t.enterpriseLogistics.digitalAssets,
          name: 2,
          count: 0,
        },
      ],
      page: 0,
      pageSize: 10,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //options
      categoryList: [],
      //filter
      searchText: "",
      acid: 0,
      state: null,
      showFilter: false,
      //添加类别
      assetTypeOptions: [],
      showAssetPicker: false,
      dialogAssetVisible: false,
      dialogAssetForm: {
        AssetTypeName: "",
        AssetType: 1,
        AssetName: "",
      },
      //操作菜单
      sheetShow: false,
      sheetActions: [],
    };
  },
  watch: {
    menuState() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.firstLoad(1);
    },
  },
  created() {},
  methods: {
    sheetSelect(e) {
      if (e.className == "1") {
        this.gotoDetail(null);
      }
      if (e.className == "2") {
        this.dialogShow();
      }
      this.sheetShow = false;
    },
    handleSheetShow() {
      var actions = [
        { name: this.$t.enterpriseLogistics.createAssets, className: "1" },
        { name: this.$t.enterpriseLogistics.addClass, className: "2" },
      ];
      this.sheetActions = actions;
      this.sheetShow = true;
    },
    assetConfirm(e) {
      this.dialogAssetForm.AssetTypeName = e.text;
      this.dialogAssetForm.AssetType = e.value;
      this.showAssetPicker = false;
    },
    pickerShow() {
      this.assetTypeOptions = [
        {
          text: this.$t.enterpriseLogistics.fixedAssets,
          value: 1,
        },
        {
          text: this.$t.enterpriseLogistics.digitalAssets,
          value: 2,
        },
      ];
      this.showAssetPicker = true;
    },
    dialogConfirm() {
      this.$commonMethod.showLoading();
      var param = this.dialogAssetForm;
      this.$api.businessLogistics
        .addAssetCategory(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.initList();
          this.firstLoad(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogCancel() {
      this.dialogAssetVisible = false;
    },
    dialogShow() {
      this.dialogAssetVisible = true;
    },
    deleteAssetInfo(id) {
      this.$commonMethod.showLoading();
      var param = {
        AssetId: id,
      };
      this.$api.businessLogistics
        .deleteAssetInfo(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.initList();
          this.firstLoad(1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "assetsStatisticsDetail",
        name: "assetsStatisticsDetail",
        query: [
          {
            name: "AssetId",
            value: id,
          },
          {
            name: "AssetType",
            value: this.menuState,
          },
        ],
      });
    },
    gotoRecord(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "assetsStatisticsRecord",
        name: "assetsStatisticsRecord",
        query: [
          {
            name: "AssetId",
            value: id,
          },
        ],
      });
    },
    onSearch() {
      this.initList();
      this.firstLoad(1);
    },
    isFilter() {
      if (this.acid || this.state) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.acid = null;
      this.state = null;
      this.initList();
      this.firstLoad(1);
    },
    filterSubmit() {
      this.initList();
      this.firstLoad(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    stateChanged(state) {
      this.menuState = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
    },
    firstLoad(page) {
      this.getAssetCategoryList(this.menuState);
      this.getList(page);
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        ACId: this.acid,
        AssetState: this.state,
        SearchNameOrModelOrBrand: this.searchText,
      };
      var request = null;
      if (this.menuState == 2) {
        request = this.$api.businessLogistics.getAssetDigitalList(param);
      } else {
        request = this.$api.businessLogistics.getAssetFixedList(param);
      }
      request
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    getAssetCategoryList(type) {
      return new Promise((resolve) => {
        this.$api.businessLogistics
          .getAssetCategoryList({
            AssetType: type,
          })
          .then((res) => {
            this.categoryList = res.data;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.assetsStatistics {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .assetsStatistics-alert {
    overflow: scroll;
    max-height: 100vw;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
